import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import factory from "utils/getApiHandlerEffect";
import { afterUserInfoLoaded, loadDashboardUserInfo } from "./redux";

export function* loadUserInformation(
  action: ReturnType<typeof loadDashboardUserInfo>
): SagaIterator {
  const apiHandler: APIHandler = yield call(() => factory());
  // TODO: Add error state
  const userInfo = yield call(() =>
    apiHandler.dashboardUserInfo(action.payload)
  );
  yield put(afterUserInfoLoaded(userInfo));
}

// Individual exports for testing
export default function* loadingSaga() {
  yield takeLatest(loadDashboardUserInfo.type, loadUserInformation);
}
